import actions from './UndergroundCasinoActions';

// Namespaced Vuex module which contains its
// own state, actions, getters, mutations.
export default {
  actions,
  namespaced: true
};
